<div class="forgot-password">
  <app-password-reset [content]="content" [globalContent]="globalContent$ | async"></app-password-reset>
</div>
